var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "document-type-card",
      class: { selected: _vm.selected },
      attrs: {
        role: "button",
        "aria-label": "Seleccionar documento tipo " + _vm.type.text,
        "aria-pressed": _vm.selected,
        tabindex: "0"
      },
      on: {
        click: function($event) {
          return _vm.$emit("click")
        },
        keydown: function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          return _vm.$emit("click")
        }
      }
    },
    [
      _c("div", { staticClass: "card-icon" }, [_vm._v(_vm._s(_vm.icon))]),
      _c("div", { staticClass: "card-title" }, [_vm._v(_vm._s(_vm.type.text))]),
      _c("div", { staticClass: "card-code" }, [
        _vm._v("(" + _vm._s(_vm.type.value) + ")")
      ]),
      _c("div", { staticClass: "card-description" }, [
        _vm._v(_vm._s(_vm.description))
      ]),
      _vm.selected
        ? _c(
            "div",
            { staticClass: "selected-indicator" },
            [
              _c("feather-icon", {
                attrs: { icon: "CheckCircleIcon", size: "24" }
              })
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }